import Card from "./card";
import PrimaryButton from "./primary-button";

export const GOALS = [
  { key: "home", label: "A home" },
  { key: "emergency", label: "Emergency fund" },
  { key: "retirement", label: "Retirement" },
  { key: "vacation", label: "Vacation" },
  { key: "car", label: "A car" },
  { key: "bills", label: "Bills" },
  { key: "college", label: "College" },
  { key: "moving", label: "Moving costs" },
  { key: "wedding", label: "A wedding" },
];

const GOAL_ICONS = {
  home: (
    <>
      <path d="M4 11l8-7 8 7" />
      <path d="M6 9.5V20h12V9.5" />
    </>
  ),
  emergency: (
    <>
      <path d="M12 3l7 3v5.5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
      <path d="M9.5 11.5l2 2 3.5-3.5" />
    </>
  ),
  retirement: (
    <>
      <path d="M12 3a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9z" />
      <path d="M12 12v7c0 1.1.9 2 2 2" />
      <path d="M12 3v2" />
    </>
  ),
  vacation: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6L7 7M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" />
    </>
  ),
  car: (
    <>
      <path d="M4 16v-3l2-5h12l2 5v3" />
      <path d="M4 13h16" />
      <circle cx="8" cy="17" r="1.5" />
      <circle cx="16" cy="17" r="1.5" />
    </>
  ),
  bills: (
    <>
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  college: (
    <>
      <path d="M12 4L2 9l10 5 10-5-10-5z" />
      <path d="M6 11.5V16c0 1.5 2.7 3 6 3s6-1.5 6-3v-4.5" />
    </>
  ),
  moving: (
    <>
      <path d="M3 8l9-4 9 4-9 4-9-4z" />
      <path d="M3 8v8l9 4 9-4V8" />
      <path d="M12 12v8" />
    </>
  ),
  wedding: (
    <>
      <circle cx="9" cy="13" r="5" />
      <circle cx="15" cy="13" r="5" />
      <path d="M12 4l1.5 2L12 8l-1.5-2L12 4z" />
    </>
  ),
};

export default function Goals({ selected, onToggle, onBack, onContinue, onSkip }) {
  return (
    <Card
      progress={20}
      onBack={onBack}
      footer={
        <>
          <PrimaryButton onClick={onContinue} disabled={!selected.length}>
            Continue
          </PrimaryButton>
          <button className="su-link" type="button" onClick={onSkip}>
            Skip for now
          </button>
        </>
      }
    >
      <h2 className="su-title">What are your savings goals?</h2>
      <p className="su-subtitle">Pick what matters to you, we’ll help you get there.</p>
      <div className="su-goals">
        {GOALS.map((goal) => {
          const isSelected = selected.includes(goal.key);
          return (
            <button
              key={goal.key}
              type="button"
              className={`su-goal${isSelected ? " is-selected" : ""}`}
              aria-pressed={isSelected}
              onClick={() => onToggle(goal.key)}
            >
              {isSelected ? (
                <span className="su-goal-check" aria-hidden="true">
                  <svg width="10" height="10" viewBox="0 0 12 12">
                    <path d="M2.5 6.2l2.4 2.4L9.5 3.8" fill="none" stroke="#0E1118" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              ) : null}
              <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                {GOAL_ICONS[goal.key]}
              </svg>
              <span>{goal.label}</span>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
